import confetti from 'canvas-confetti';

let confettiTriggered = false;

function triggerConfetti() {
  // Prevent multiple triggers
  if (confettiTriggered) return;
  confettiTriggered = true;

  // Reset after animation completes
  setTimeout(() => {
    confettiTriggered = false;
  }, 2500);

  const duration = 2000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function () {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    // Launch confetti from both sides
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
    });
  }, 250);
}

// Listen for push_event from LiveView
window.addEventListener('phx:triggerConfetti', () => {
  triggerConfetti();
});

export default {
  Confetti: {
    mounted() {
      // This hook is registered but the push_event listener handles the confetti
    },
  },
};
